<template>
    <div class="fixed-content">
        <div class="fixed-btn" @click="$router.push('/device')">
            <span class="fixed-btn-text">驱动下载</span>
            <img src="./images/download.png" alt="icon">
        </div>
        <div class="fixed-btn" @click="openNew('https://work.weixin.qq.com/kfid/kfc1d496dbb43b6f822')">
            <span class="fixed-btn-text">在线客服</span>
            <img src="./images/kefu.png" alt="icon">
        </div>
        <div class="fixed-btn" @click="openNew('https://mall.jd.com/index-12471453.html')">
            <span class="fixed-btn-text">购买机器</span>
            <img src="./images/shopping.png" alt="icon">
        </div>
        <div class="fixed-btn">
            <span class="fixed-btn-text">渠道招商：18969120021（周一至周五9:00-18:00)</span>
            <img src="./images/zs.png" alt="icon">
        </div>
        <div class="fixed-btn-top" @click="toTop"></div>
    </div>
</template>

<script>
export default {
    name: "FixedBox",
    data() {
        return {};
    },
    mounted() {
    },
    methods: {
        toTop() {
            window.scrollTo({
                top: 0, // 滚动到顶部的位置
                behavior: 'smooth' // 实现平滑滚动
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.fixed-content {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 12rem;
    position: fixed;
    right: 40rem;
    top: 396rem;
    z-index: 9999;

    .fixed-btn {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10rem;
        cursor: pointer;
        background: #FD6520;
        border-radius: 100rem;

        &:hover {
            gap: 8rem;

            .fixed-btn-text {
                opacity: 1;
                transform: translate3d(0, 0, 0);
                width: auto;
                padding: 0 0 0 6rem;
            }
        }

        .fixed-btn-text {
            opacity: 0;
            transform: translate3d(100%, 0, 0);
            width: 0;
            overflow: hidden;
            white-space: nowrap;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 14rem;
            color: #FFFFFF;
            transition: all 0.5s;
        }

        img {
            width: 28rem;
            height: 28rem;
        }
    }

    .fixed-btn-top {
        box-sizing: border-box;
        width: 48rem;
        height: 48rem;
        background: #FFFFFF url("./images/top.png") center / 28rem no-repeat;
        cursor: pointer;
        border-radius: 100rem;

        &:hover {
            background: #FD6520 url("./images/top-.png") center / 28rem no-repeat;
        }
    }
}
</style>
